<template>
    <reo-dialog
        ref="addon-dialog"
        class="addon-desc-dialog"
        :title="$t('addon_desc_dialog_title')"
        @cancel="handleCancel"
    >
        <div class='addon-desc'>
            <p class='context'>{{ $t('addon_desc_dialog_li_1') }}</p>
            <p>{{$t('addon_desc_dialog_li_2_title')}}</p>
            <p class='context'>{{$t('addon_desc_dialog_li_2_context')}}</p>
            <p>{{$t('addon_desc_dialog_li_3_title')}}</p>
            <p class='context'>{{$t('addon_desc_dialog_li_3_context')}}</p>
            <p>{{$t('addon_desc_dialog_li_4_title')}}</p>
            <p class='context'>{{$t('addon_desc_dialog_li_4_context')}}</p>
        </div>
    </reo-dialog>
</template>

<script lang="ts">
import Vue from 'vue';
import ReoDialog from '@/basic/Dialog.vue';

export default Vue.extend({
    name: 'AddOnDesc',
    components: {
        ReoDialog
    },
    data () {

        return {
        };

    },
    methods: {
        handleCancel() {

            this.$emit( 'cancel' );

        }
    }
});
</script>

<style lang="less" scoped>
    .addon-desc-dialog{
        @media @snapeak_mobile{
            /deep/ .reo-dialog-inner{
                width: 100%;
            }
        }
    }
    .addon-desc{
        text-align: left;
        color: @font_primary;
        font-size: 17px;
        @media @snapeak_mobile{
            font-size: 14px;
        }
        p.context{
            margin-bottom: 10px;
        }
    }
</style>
